import { render, staticRenderFns } from "./PlantillasWaApi.vue?vue&type=template&id=3edcbfe3&"
import script from "./PlantillasWaApi.vue?vue&type=script&lang=js&"
export * from "./PlantillasWaApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports